<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="relative flex items-center -mt-10">
      <div @click="handleClose" class="cursor-pointer absolute left-0">
        <arrow-left />
      </div>
      <h4 class="mx-auto font-semibold text-root-4 md:text-xl">
        Reason For Transfer
      </h4>
    </div>
    <div class="radios flex flex-col gap-y-4 mt-12 w-full">
      <el-radio
        v-for="reason in reasons"
        :key="reason.id"
        v-model="transferReason"
        :label="reason.name"
        class="text-root-4 font-normal py-5 border border-solid rounded-lg px-4 w-full animation transition-all duration-300"
        :class="{
          'pb-28 mb-4':
            transferReason === 'Custom Reason' &&
            reason.name === 'Custom Reason'
        }"
        >{{ reason.name }}</el-radio
      >
      <div
        v-if="transferReason === 'Custom Reason'"
        class="flex items-center justify-center -mt-28 z-10"
      >
        <textarea
          v-model="customReason"
          class="outline-none border rounded-lg px-4 py-2 h-16 text-sm w-11/12 opacity-0"
          :class="{ 'opacity-100': customReasonOpacity }"
          placeholder="Type a custom reason"
        >
        </textarea>
      </div>
    </div>
    <div class="continue-button flex items-center mt-8">
      <el-button
        class="g-root-5 text-white text-xs font-normal text-center w-full rounded transition-all duration-300 hover:opacity-70 py-4 md:text-sm"
        :disabled="!reasonHandler"
        :class="{
          'bg-primary': reasonHandler,
          'cursor-not-allowed': !reasonHandler
        }"
        @click="nextHandler"
      >
        {{ 'Next' }}</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'

export default {
  name: 'TransferReason',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints,
      transferReason: '',
      customReason: '',
      customReasonOpacity: false,
      reasons: [
        {
          name: 'Salary Payment',
          id: 1
        },
        {
          name: 'Flight Booking',
          id: 2
        },
        {
          name: 'Paying Partners',
          id: 3
        },
        {
          name: 'Custom Reason',
          id: 4
        }
      ]
    }
  },
  components: {
    ArrowLeft: () => import('@/assets/icons/ArrowLeft.vue')
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    reasonHandler () {
      return (
        (this.transferReason && this.transferReason !== 'Custom Reason') ||
        this.customReason.length > 4
      )
    }
  },
  methods: {
    nextHandler () {
      // for custom reason
      if (this.transferReason !== 'Custom Reason') {
        this.$emit('next', this.transferReason)
      } else {
        if (this.customReason.length > 4) {
          this.$emit('next', this.customReason)
        }
      }
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  watch: {
    transferReason (newVal) {
      if (newVal === 'Custom Reason') {
        setTimeout(() => {
          this.customReasonOpacity = true
        }, 200)
      } else {
        this.customReasonOpacity = false
      }
    }
  }
}
</script>

<style scoped>
.slide-fade-enter-active {
  animation: slide-fade 0.3s ease forwards;
}
.slide-fade-leave-active {
  animation: slide-fade 0.3s ease forwards alternate-reverse;
}
@media screen and (max-width: 768px) {
  >>> .el-radio__label {
    font-size: 12px;
  }
}
>>> .el-dialog {
  border-radius: 0.5rem !important;
}
>>> .el-radio__inner {
  height: 1.2rem;
  width: 1.2rem;
  border: 2px solid #bdbdbd;
}
@media screen and (min-width: 1280px) {
  >>> .el-dialog {
    margin-right: 28vw;
  }
}
@media screen and (min-width: 1680px) {
  >>> .el-dialog {
    margin-right: 29vw;
  }
}
</style>
